import React, {createContext, useContext} from 'react';

/**
 * Context to indicate when Weave components are rendered within a workspace panel
 * rather than in the full Weave application. This helps components decide whether
 * to use React Router navigation (within full app) or full page navigation (from workspace).
 */
interface WeaveInWorkspaceContextType {
  isInWorkspace: boolean;
}

const WeaveInWorkspaceContext = createContext<
  WeaveInWorkspaceContextType | undefined
>(undefined);

export const WeaveInWorkspaceProvider: React.FC<{
  children: React.ReactNode;
}> = ({children}) => {
  return (
    <WeaveInWorkspaceContext.Provider value={{isInWorkspace: true}}>
      {children}
    </WeaveInWorkspaceContext.Provider>
  );
};

export const useWeaveInWorkspace = (): WeaveInWorkspaceContextType => {
  const context = useContext(WeaveInWorkspaceContext);
  return context ?? {isInWorkspace: false};
};
